import { PathnamesMap } from '../constants/ui';
import type { NavigateFunction } from 'react-router-dom';

type NavigateProps = {
  id: string;
  date: string;
  navigate: NavigateFunction;
};

export const goToTimeline = ({ id, date, navigate }: NavigateProps) => {
  navigate({
    pathname: `/${PathnamesMap.timeline}/${id}`,
    search: `?date=${date}`,
  });
}

export const goToChartsSoil = ({ id, date, navigate }: NavigateProps) => {
  navigate({
    pathname: `/${PathnamesMap.soilSensorCharts}/${id}`,
    search: `?date=${date}`,
  }, { replace: true });
}